module.exports = __webpack_public_path__ + "img/logo.8faf8527.png";